import { FigmaFeatures } from "../../components/FigmaFeatures";
import { FigmaCoverage } from "../../components/FigmaCoverage";
import { FigmaHowItWorks } from "../../components/FigmaHowItWorks";
import { FigmaRegistration } from "../../components/FigmaRegistration";
import { FigmaFAQ } from "../../components/FigmaFAQ";
import { FigmaObligatoryRegistration } from "../../components/FigmaObligatoryRegistration";
import { FigmaCTA } from "../../components/FigmaCTA";
import Header from "../../components/Header/Header";
import Banner from "../../components/Banner/Banner";
import { URLS, VIEWS } from "../../utils/constants";

interface LandingProps {
  handleChangeView: (view: (typeof VIEWS)[keyof typeof VIEWS]) => void;
}

const Landing = ({ handleChangeView }: LandingProps) => {
  const handleClick = () => {
    window.location.href =
      URLS.PC_COMPONENTES_INSURANCE; /* Redirige a la URL del seguro de PC Componentes */
  };

  return (
    <>
      <div className="bg-white">
        <Header />
        <Banner handleClick={handleClick} />
      </div>
      <FigmaFeatures />
      <FigmaCoverage handleClick={handleClick} />
      <FigmaHowItWorks />
      <FigmaRegistration />
      <FigmaFAQ />
      <FigmaObligatoryRegistration />
      <FigmaCTA handleClick={handleClick} />
    </>
  );
};

export default Landing;
